import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import CardMotorista from './cardMotorista';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''


var codunidadetransporte='';
var utipo='';
var depnome='';
var stmotora="1";
export const  Motoristas = withRouter(({history}) => {
 
  const [state, setState] = useState([]);

   React.useEffect(() => {
    
   

    async function pegauser() {
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
      await userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("Document data pegouppqpq:", doc.data());
           utipo = doc.data().usertipo;
           codunidadetransporte = doc.data().codunidadetransporte;
           
            //console.log('porraaaaa' , doc.data().lotacao);
            
            pegalista();
            
         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
          alert("Erro ao localizar o seu cadastro ", error.message);
          })
    };

    
 
    pegauser()
    
  
  
  console.log('agora sim é o tamanho ', state.length);
  }, [0]); 



  //**************** */
  async function pegalista() { 
    setState([]);
    if(stmotora=="1"){
      
    if((utipo==6)||(utipo==7)) {
     //console.log("user tipo poxa"+ codunidadetransporte);
     var db = firebase.firestore();
     var query = await db.collection("usuarios").where("usertipo", "in", ['11',"17"]).
     where("codunidadetransporte","==", codunidadetransporte).orderBy("nome").get()
     .then(function(querySnapshot) {
      console.log("entrou na porra do doc pega unidade motoras");
      querySnapshot.forEach(function(doc) {
        var listausers=[];
          listausers.push({id: doc.id, nome: doc.data().nome,
            matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
          usertipo: doc.data().usertipo, codunidadetransporte: doc.data().codunidadetransporte, 
          cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
        email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh , novo:false
      });
        console.log("veiculos pqp ", listausers );
       setState (currentArray => [...currentArray, listausers]);
       

      });//***********************
      
              
    })
   .catch(error => {
       console.log('Não encontramos motoristas cadastrados', error);
       alert("'Não encontramos motoristas cadastrados'");
   });
   
   }else {
    
   
    await firebase.firestore().collection("usuarios").where("usertipo", 'in', ['17','11']).get()
    .then(function(querySnapshot) {

      querySnapshot.forEach(function(doc) {
        var listausers=[];
          listausers.push({id: doc.id, nome: doc.data().nome,
            matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
          usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte,
          cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
        email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh });
        console.log("veiculos pqp ", state );
       setState (currentArray => [...currentArray, listausers]);
       

      });
     
    })
   .catch(error => {
       console.log('Não encontramos motoristas cadastrados', error);
       alert("'Não encontramos motoristas cadastrados'");
   });
   
    
   }
  }else{
    if (stmotora=="2") {

      if((utipo==6)||(utipo==7)) {
        //console.log("user tipo poxa"+ codunidadetransporte);
        var db = firebase.firestore();
        var query = await db.collection("usuarios").where("usertipo", "in", ['11',"17"]).
        where("codunidadetransporte","==", codunidadetransporte).where("userstatus","==",true).orderBy("nome").get()
        .then(function(querySnapshot) {
         console.log("entrou na porra do doc pega unidade motoras");
         querySnapshot.forEach(function(doc) {
           var listausers=[];
             listausers.push({id: doc.id, nome: doc.data().nome,
               matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
             usertipo: doc.data().usertipo, codunidadetransporte: doc.data().codunidadetransporte, 
             cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
           email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh , novo:false
         });
           console.log("veiculos pqp ", listausers );
          setState (currentArray => [...currentArray, listausers]);
          
   
         });//***********************
         
                 
       })
      .catch(error => {
          console.log('Não encontramos motoristas cadastrados', error);
          alert("'Não encontramos motoristas cadastrados'");
      });
      
      }else {
       
      
       await firebase.firestore().collection("usuarios").where("usertipo", 'in', ['17','11']).where("userstatus","==",true).get()
       .then(function(querySnapshot) {
   
         querySnapshot.forEach(function(doc) {
           var listausers=[];
             listausers.push({id: doc.id, nome: doc.data().nome,
               matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
             usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte,
             cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
           email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh });
           console.log("veiculos pqp ", state );
          setState (currentArray => [...currentArray, listausers]);
          
   
         });
        
       })
      .catch(error => {
          console.log('Não encontramos motoristas cadastrados', error);
          alert("'Não encontramos motoristas cadastrados'");
      });
      
       
      }
      
    } else {
      if (stmotora=="3") {

        if((utipo==6)||(utipo==7)) {
          //console.log("user tipo poxa"+ codunidadetransporte);
          var db = firebase.firestore();
          var query = await db.collection("usuarios").where("usertipo", "in", ['11',"17"]).
          where("codunidadetransporte","==", codunidadetransporte).where("userstatus","==",false).orderBy("nome").get()
          .then(function(querySnapshot) {
           console.log("entrou na porra do doc pega unidade motoras");
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,
                 matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
               usertipo: doc.data().usertipo, codunidadetransporte: doc.data().codunidadetransporte, 
               cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
             email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh , novo:false
           });
             console.log("veiculos pqp ", listausers );
            setState (currentArray => [...currentArray, listausers]);
            
     
           });//***********************
           
                   
         })
        .catch(error => {
            console.log('Não encontramos motoristas cadastrados', error);
            alert("'Não encontramos motoristas cadastrados'");
        });
        
        }else {
         
        
         await firebase.firestore().collection("usuarios").where("usertipo", 'in', ['17','11']).where("userstatus","==",false).get()
         .then(function(querySnapshot) {
     
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,
                 matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
               usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte,
               cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
             email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh });
             console.log("veiculos pqp ", state );
            setState (currentArray => [...currentArray, listausers]);
            
     
           });
          
         })
        .catch(error => {
            console.log('Não encontramos motoristas cadastrados', error);
            alert("'Não encontramos motoristas cadastrados'");
        });
        
         
        }
      
      }
      
    }
  }

   
 


}
  //***************** */

  

  const handleChangeman=(event)=>{
    var v = event.target.value;
    stmotora=v;
    pegalista();
  }
 
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Motoristas
          </Typography>
          <Container align='center'>
        <Grid container align="center">
        <Grid item xs>
          <FormControl component="fieldset">
      
      <RadioGroup row  aria-label="gender" name="gender1" value={stmotora} onChange={handleChangeman}>
        <FormControlLabel value="1" control={<Radio />} label="Todos" />
         <FormControlLabel value="2" control={<Radio />} label="Ativos" />
         <FormControlLabel value="3" control={<Radio />} label="Inativos" />
        </RadioGroup>
    </FormControl>
    </Grid>
    </Grid>
    </Container>
          
      <div id="corpo"   align="center" className={classes.paper} >

      

         <div id="corpoveiculo">
           <Container maxWidth="xs">
           <Grid container>
             
             {state.map(item=>(
              <Grid item key={item.id } xs={12} >
             <CardMotorista props={item} id={item.id} />
             </Grid>
             ))}
              </Grid>
             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Motoristas;
